import { 
  getUrgentlyAdditionalCostsRoutine,
  createUrgentlyAdditionalCostRoutine,
  clearLocalUrgentlyAdditionalCostsRoutine
} from 'actions';

const initialState = {
  all: {
    data: [],
    pagination: {
      count: 0,
      offset: 0,
      limit: 10,
      total_count: 0
    }
  },
  active: {}
};

const urgentlyAdditionalCostsReducer = (state = initialState, action) => {
  switch (action.type) {
    case getUrgentlyAdditionalCostsRoutine.SUCCESS: {
      const { urgently_additional_costs, pagination } = action.payload.data;
      return {
        ...state,
        all: {
          data: pagination.offset === 0 
            ? urgently_additional_costs 
            : [...state.all.data, ...urgently_additional_costs],
          pagination
        }
      };
    }
    case createUrgentlyAdditionalCostRoutine.SUCCESS: {
      const { urgently_additional_cost } = action.payload.data;
      return {
        ...state,
        all: {
          ...state.all,
          data: [urgently_additional_cost, ...state.all.data],
          pagination: {
            ...state.all.pagination,
            count: state.all.pagination.count + 1,
            total_count: state.all.pagination.total_count + 1
          }
        }
      };
    }
    case clearLocalUrgentlyAdditionalCostsRoutine.SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default urgentlyAdditionalCostsReducer;
